/* eslint-disable sort-keys */
export const mediaQueriesNum = {
  xlarge: 1920,
  large: 1600,
  desktop: 1440,
  medium: 1280,
  small: 960,
  tablet: 768,
  xsmall: 600,
  xxsmall: 350,
  xxxsmall: 320, // WCAG 2.1 AA 1.4.10 compliance
};

/* eslint-disable sort-keys */
const mediaQueries = {
  xlarge: `${mediaQueriesNum.xlarge}px`,
  large: `${mediaQueriesNum.large}px`,
  desktop: `${mediaQueriesNum.desktop}px`,
  medium: `${mediaQueriesNum.medium}px`,
  small: `${mediaQueriesNum.small}px`,
  tablet: `${mediaQueriesNum.tablet}px`,
  xsmall: `${mediaQueriesNum.xsmall}px`,
  xxsmall: `${mediaQueriesNum.xxsmall}px`,
  xxxsmall: `${mediaQueriesNum.xxxsmall}px`,
};

const {
  xlarge,
  large,
  desktop,
  medium,
  small,
  tablet,
  xsmall,
  xxsmall,
  xxxsmall,
} = mediaQueries;

const queries = {
  xlarge: `(max-width: ${xlarge})`,
  large: `(max-width: ${large})`,
  desktop: `(min-width: ${desktop})`,
  medium: `(max-width: ${medium})`,
  small: `(max-width: ${small})`,
  tablet: `(min-width: ${tablet})`,
  xsmall: `(max-width: ${xsmall})`,
  xxsmall: `(max-width: ${xxsmall})`,
  xxxsmall: `(max-width: ${xxxsmall})`,
  touch: '(pointer: coarse)',
};

export default queries;
